Vue.component('spark-widget', {

    data() {
        return {
            token: null,
            periodSelected: null,
            message: '',
            messageSlider: '',
            showScript: false,
            showScriptSlider: false,
            bgColor: '#edf0f2',
            bgSlideColor: '#FFFFFF',
            bgFontColor: '#727272',
            bgStarColor: '#F7C800',
            amount: 5,
            type: 'both',
            urlSlider: ''
        }
    },

    computed: {
        selectOptions() {
            return [
                {id: 'last-month', name: 'In the last month'},
                {id: '3-months-ago', name: 'In the last three months'},
                {id: '6-months-ago', name: 'In the last six months'},
                {id: 'last-year', name: 'In the last year'},
            ]
        },
        buttonEnabled() {
            return this.periodSelected !== null
        },

        iframeStyle() {
            return `style="border:none; margin:0; padding:0; overflow:hidden; height: 1200px; width: 800px"`;
        },

        defaultUrl() {
            return `${window.location.origin}/external-review-company?`;
        },

        reviewScript() {
            return `<iframe src="${this.reviewUrl}" ${this.iframeStyle}></iframe>`;
        },

        sliderScript() {
            this.bgColor = this.bgColor.replace('#', '');
            this.bgSlideColor = this.bgSlideColor.replace('#', '');
            this.bgFontColor = this.bgFontColor.replace('#', '');
            this.bgStarColor = this.bgStarColor.replace('#', '');
            this.urlSlider = encodeURI(`${window.location.origin}/external-review-company-slider?token=${this.token}&amount=${this.amount}&bgcolor=${this.bgColor}&bgslidecolor=${this.bgSlideColor}&bgfontcolor=${this.bgFontColor}&bgstarcolor=${this.bgStarColor}`);

            const script = `
            <iframe src="${this.urlSlider}" style="border:none; margin:0; padding:0; overflow:hidden; height: 350px; width: 100%"></iframe>
            `;

            return script;
        },

        reviewUrl() {
            this.bgColor = this.bgColor.replace('#', '');
            return encodeURI(`${this.defaultUrl}token=${this.token}&type=${this.type}` +
                `&period=${this.periodSelected.id}&bgcolor=${this.bgColor}`);
        }
    },

    created(){
        this.resolveToken();
    },

    methods: {
        gerenateScript() {

            this.message = this.reviewScript;
            this.showScript = true;
        },

        async resolveToken() {
            if (this.token) {
                return;
            }
            const {data} = await this.$http.post('/api/locations/generate-review-token-all');

            this.token = data;
        },

        generateScriptToSlider() {
            this.generateToken();
            this.messageSlider = this.sliderScript;
            this.showScriptSlider = true;
        },
        openPreview() {
            window.open(this.reviewUrl, '_blank');
        },
        openPreviewSlider() {
            window.open(this.urlSlider, '_blank');
        },
    }
});
